import { Layout, theme } from "antd";
import React, { useState, useMemo } from "react";
import { Route, Routes } from "react-router-dom";
import MobileMenuDrawer from "./MobileMenuDrawer";
import Top from "./Top";
import routes, { AppRoute } from "./routes";
import SidebarMenu from "./SidebarMenu";
import { Link } from "react-router-dom";
import { checkRightAccess } from "../../lib/utils";
import { useAuthStore } from "../../store/slices/user";

const newRoutes: AppRoute[] = [];

function convertMultiToSingle(arr: AppRoute[], prevBaseUrl: string = ""): void {
  arr.forEach((v) => {
    if (v.children) {
      convertMultiToSingle(v.children, prevBaseUrl + v.url);
    } else if (!v.ignore) {
      newRoutes.push({ ...v, url: prevBaseUrl + v.url });
    }
  });
}

convertMultiToSingle([...routes]);

const MyLayout: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  const { userInfo } = useAuthStore();

  const allowedRoutes = useMemo(() => {
    if (!userInfo) return [];
    return newRoutes.filter((r) => checkRightAccess(r.type, userInfo));
  }, [userInfo]);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  return (
    <Layout className="flex min-h-screen bg-white">
      <Layout.Sider
        collapsible
        width={340}
        collapsedWidth={80}
        collapsed={collapsed}
        trigger={null}
        className="hidden lg:flex lg:flex-col bg-[#F69439] rounded-r-3xl h-screen sticky top-0 overflow-hidden"
      >
        <div
          className={`
            p-4 pt-6
            flex items-center
            ${collapsed ? "justify-center" : "justify-start"}
          `}
        >
          <Link to="/">
            <img
              src="/lightLogo.svg"
              alt="Logo"
              className="w-44 h-20 object-contain"
            />
          </Link>
        </div>

        <div className="flex-1 overflow-y-auto">
          <SidebarMenu collapsed={collapsed} routes={allowedRoutes} />
        </div>
      </Layout.Sider>

      <MobileMenuDrawer open={open} setOpen={setOpen} />

      <Layout className="flex flex-col flex-1 min-w-0">
        <Top
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          showDrawer={() => setOpen(true)}
        />

        <Layout.Content
          className="
            flex-1 
            overflow-y-auto 
            p-3 sm:p-5 
            bg-white 
            text-black
          "
        >
          <div className="min-h-full">
            <Routes>
              {allowedRoutes.map((route) =>
                route.component && route.url ? (
                  <Route
                    key={route.url}
                    path={route.url}
                    element={React.createElement(route.component)}
                  />
                ) : null
              )}
            </Routes>
          </div>
        </Layout.Content>
      </Layout>
    </Layout>
  );
};

export default MyLayout;